export const LOCALES = {
	ENGLISH: 'en',
	FINNISH: 'fi-FI',
	SWEDISH: 'sv-FI',
}
